const refererDetailOptions = [
    {
        value: 'instagram',
        label: 'Instagram Ad',
    },
    {
        value: 'facebook',
        label: 'Facebook Ad',
    },
    {
        value: 'influencer',
        label: 'Influencer',
    },
    {
        value: 'friend',
        label: 'Invited by a friend',
    },
    {
        value: 'social-media',
        label: 'Social media (Instagram, TikTok, Youtube, Etc)',
    },
    {
        value: 'search',
        label: 'Google/Search Engine',
    },
    {
        value: 'other',
        label: 'Other',
    },
]

export default refererDetailOptions
